import PageContent from "../components/PageContent";


export default function LoyaltyPage() {
    return (
       <PageContent title="Loyalty Page">
        
        <h3>Note: Feature Coming Soon. Please check back later for updates.</h3>
       </PageContent>
    );
}